import { defaultTheme } from 'react-admin';
import { createTheme } from '@mui/material/styles';

const airForceBlue = '#00308F';
const airForceLight = '#4472C4';
const airForceDark = '#001F5B';
const steelGray = '#6C757D';
const lightGray = '#F4F6F8';
const white = '#FFFFFF';

export const theme = createTheme({
  ...defaultTheme,
  palette: {
    primary: {
      main: airForceBlue,
      light: airForceLight,
      dark: airForceDark,
      contrastText: white,
    },
    secondary: {
      main: steelGray,
      light: '#ADB5BD',
      dark: '#495057',
      contrastText: white,
    },
    background: {
      default: lightGray,
      paper: white,
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h6: {
      fontWeight: 600,
    },
    body1: {
      fontSize: '0.9375rem',
    },
    body2: {
      fontSize: '0.875rem',
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  components: {
    ...defaultTheme.components,
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
      defaultProps: {
        elevation: 0,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid #E0E0E0',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            fontWeight: 600,
            backgroundColor: lightGray,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});
